import React from 'react';
import { useTranslation } from "react-i18next";
import ReportPage from '../ReportChart/ReportPage';
import { getDefectsByStatus } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const DefectsStatusReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();
  const { t } = useTranslation();

  const chartConfig = {
    id: 'defects-by-status',
    title: t("option.entityByStatus", { entity: customCaptions?.defectPlural }),
    fetchData: async (params) => {
      return await getDefectsByStatus(params);
    },
    allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
    defaultChartType: 'tree-map',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{ 
        label: t("label.count")
      }]
    },
    series: [
      { 
        label: t("label.count"),
        key: 'count', 
        showLegend: false,
        colors: getAllColors()
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      department: { multiSelect: true },
      model: true,
      riskRatings: true
    },
    viewData: '/app/defects',
    itemNavigation: true,
    drilldown: {
      defaultChartType: 'tree-map',
      allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{ 
          label: t("label.count") 
        }]
      },
      series: [
        { 
          label: t("label.count"),
          key: 'count', 
          showLegend: false,
          colors: getAllColors()
        }
      ],
      currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
      getParams: (dataPoint) => {
        return {
          defectStatusId: dataPoint.id,
          // LEGACY HANDLING: Add the legacy status structure for backward compatibility
          defectStatus: {
            id: dataPoint.id,
            name: dataPoint.name || "Show All"
          }
        };
      }
    }
  };

  return (
    <ReportPage 
      title={t("option.entityByStatus", { entity: customCaptions?.defectPlural })}
      chartConfig={chartConfig}
    />
  );
};

export default DefectsStatusReport; 